export default __webpack_public_path__ + "static/media/right-chevron-grey.a97b13f4.svg";